import ElementsItemsBlock from './elementsItemsBlock'

export default ElementsItemsBlock
